var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ticket-validate" },
    [
      _vm.isDeepLink
        ? _c(
            "vx-card",
            { staticClass: "mb-base" },
            [
              _vm.previewLoading
                ? _c("div", { staticClass: "tv-center" }, [
                    _c("i", { staticClass: "feather icon-loader tv-spin" }),
                    _c("p", { staticClass: "mt-2 mb-0" }, [
                      _vm._v("Carregando ingresso..."),
                    ]),
                  ])
                : _vm.preview
                ? [
                    _c("h4", { staticClass: "mb-1" }, [
                      _vm._v("Confirmar entrada"),
                    ]),
                    _c("p", { staticClass: "tv-muted mb-3" }, [
                      _vm._v(
                        " Confira a pessoa e toque em confirmar. Abrir o link não registra entrada. "
                      ),
                    ]),
                    _c("ticket-result", { attrs: { result: _vm.preview } }),
                    _c(
                      "div",
                      { staticClass: "tv-actions mt-3" },
                      [
                        _c(
                          "vs-button",
                          {
                            attrs: {
                              disabled:
                                !_vm.preview.can_check_in || _vm.confirming,
                            },
                            on: { click: _vm.confirmDeepLink },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.confirming
                                    ? "Confirmando..."
                                    : "Confirmar entrada"
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "vs-button",
                          {
                            attrs: { type: "border" },
                            on: { click: _vm.goToScanner },
                          },
                          [_vm._v("Abrir o leitor")]
                        ),
                      ],
                      1
                    ),
                  ]
                : _c(
                    "div",
                    { staticClass: "tv-center" },
                    [
                      _c("i", {
                        staticClass: "feather icon-alert-circle tv-icon-danger",
                      }),
                      _c("p", { staticClass: "mt-2 mb-0" }, [
                        _vm._v(
                          _vm._s(_vm.previewError || "Ingresso não encontrado.")
                        ),
                      ]),
                      _c(
                        "vs-button",
                        {
                          staticClass: "mt-3",
                          attrs: { type: "border" },
                          on: { click: _vm.goToScanner },
                        },
                        [_vm._v("Abrir o leitor")]
                      ),
                    ],
                    1
                  ),
            ],
            2
          )
        : [
            _c("vx-card", { staticClass: "mb-base" }, [
              _c("div", { staticClass: "tv-toolbar" }, [
                _c(
                  "div",
                  { staticClass: "tv-field" },
                  [
                    _c("label", { staticClass: "tv-label" }, [
                      _vm._v("Evento"),
                    ]),
                    _c("v-select", {
                      attrs: {
                        options: _vm.selectableItems,
                        clearable: false,
                        reduce: function (item) {
                          return item
                        },
                        label: "name",
                        placeholder: "Escolha o evento",
                        disabled: _vm.itemsLoading,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "option",
                          fn: function (item) {
                            return [
                              _vm._v(" " + _vm._s(item.name) + " "),
                              item.occurrences_today
                                ? _c(
                                    "span",
                                    { staticClass: "tv-badge-today" },
                                    [_vm._v("hoje")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.selectedItem,
                        callback: function ($$v) {
                          _vm.selectedItem = $$v
                        },
                        expression: "selectedItem",
                      },
                    }),
                    !_vm.itemsLoading && !_vm.items.length
                      ? _c("small", { staticClass: "tv-muted" }, [
                          _vm._v(
                            " Nenhum evento com ingresso está atribuído a você. "
                          ),
                        ])
                      : _vm.isAllItems
                      ? _c("small", { staticClass: "tv-muted" }, [
                          _vm._v(
                            " Digite o CPF e o sistema encontra a sessão. Para validar por código, escolha o evento. "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", { staticClass: "tv-modes" }, [
                  _c(
                    "button",
                    {
                      class: [
                        "tv-mode",
                        { "tv-mode--on": _vm.mode === "camera" },
                      ],
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.setMode("camera")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "feather icon-camera" }),
                      _vm._v(" Câmera "),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      class: [
                        "tv-mode",
                        { "tv-mode--on": _vm.mode === "manual" },
                      ],
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.setMode("manual")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "feather icon-edit-3" }),
                      _vm._v(" Digitar "),
                    ]
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "vx-row" }, [
              _c(
                "div",
                { staticClass: "vx-col w-full lg:w-1/2 mb-base" },
                [
                  _c(
                    "vx-card",
                    [
                      _vm.mode === "camera"
                        ? [
                            _vm.cameraAvailable
                              ? _c("ticket-scanner", {
                                  attrs: { paused: _vm.scannerPaused },
                                  on: {
                                    detected: _vm.onDetected,
                                    unsupported: _vm.onCameraUnsupported,
                                    denied: _vm.onCameraDenied,
                                  },
                                })
                              : _c(
                                  "div",
                                  { staticClass: "tv-camera-fallback" },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "feather icon-camera-off tv-icon-muted",
                                    }),
                                    _c("p", { staticClass: "mt-2 mb-1" }, [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.cameraMessage)),
                                      ]),
                                    ]),
                                    _c("p", { staticClass: "tv-muted mb-2" }, [
                                      _vm._v(
                                        ' O QR do ingresso é um link: a câmera nativa do celular lê e abre esta tela já com o ingresso carregado. Ou use a aba "Digitar". '
                                      ),
                                    ]),
                                    _c(
                                      "vs-button",
                                      {
                                        attrs: {
                                          size: "small",
                                          type: "border",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.setMode("manual")
                                          },
                                        },
                                      },
                                      [_vm._v(" Digitar código ")]
                                    ),
                                  ],
                                  1
                                ),
                          ]
                        : [
                            _c(
                              "form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    return _vm.submitManual.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "tv-field mb-2" },
                                  [
                                    _c("label", { staticClass: "tv-label" }, [
                                      _vm._v(_vm._s(_vm.manualLabel)),
                                    ]),
                                    _c("vs-input", {
                                      ref: "manualInput",
                                      staticClass: "w-full tv-manual-input",
                                      attrs: {
                                        placeholder: _vm.manualPlaceholder,
                                        autocomplete: "off",
                                        autocapitalize: "characters",
                                      },
                                      model: {
                                        value: _vm.manualValue,
                                        callback: function ($$v) {
                                          _vm.manualValue = $$v
                                        },
                                        expression: "manualValue",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "vs-button",
                                  {
                                    staticClass: "w-full",
                                    attrs: {
                                      disabled:
                                        !_vm.manualValue ||
                                        !_vm.selectedItem ||
                                        _vm.validating,
                                    },
                                    on: { click: _vm.submitManual },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.validating
                                            ? "Validando..."
                                            : "Validar"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            !_vm.selectedItem
                              ? _c("p", { staticClass: "tv-muted mt-2 mb-0" }, [
                                  _vm._v(
                                    " Escolha o evento antes de validar por código ou CPF. "
                                  ),
                                ])
                              : _vm._e(),
                          ],
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "vx-col w-full lg:w-1/2 mb-base" },
                [
                  _c(
                    "vx-card",
                    [
                      _vm.choice
                        ? [
                            _c("div", { staticClass: "tv-choice__head" }, [
                              _c("div", { staticClass: "tv-choice__name" }, [
                                _vm._v(_vm._s(_vm.choice.holder.name)),
                              ]),
                              _vm.choice.holder.document_masked
                                ? _c("div", { staticClass: "tv-muted" }, [
                                    _vm._v(
                                      " CPF " +
                                        _vm._s(
                                          _vm.choice.holder.document_masked
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _c("p", { staticClass: "tv-choice__ask" }, [
                              _vm._v(_vm._s(_vm.choice.message)),
                            ]),
                            _c(
                              "ul",
                              { staticClass: "tv-choice__list" },
                              _vm._l(
                                _vm.choice.candidates,
                                function (candidate) {
                                  return _c(
                                    "li",
                                    {
                                      key: candidate.occurrence
                                        .scheduled_event_id,
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "tv-choice__option",
                                          class: {
                                            "tv-choice__option--used":
                                              candidate.already_checked_in,
                                          },
                                          attrs: {
                                            type: "button",
                                            disabled: _vm.validating,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.confirmChoice(
                                                candidate
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "tv-choice__hour" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  candidate.occurrence
                                                    .start_time
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "tv-choice__body" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "tv-choice__item",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(candidate.item.name)
                                                  ),
                                                ]
                                              ),
                                              !_vm.isToday(
                                                candidate.occurrence.date
                                              )
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "tv-choice__otherday",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.formatDate(
                                                              candidate
                                                                .occurrence.date
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              candidate.already_checked_in
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "tv-choice__used",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " já entrou às " +
                                                          _vm._s(
                                                            (
                                                              candidate.check_in
                                                                .at || ""
                                                            ).slice(11, 16)
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : candidate.occurrence.end_time
                                                ? _c(
                                                    "span",
                                                    { staticClass: "tv-muted" },
                                                    [
                                                      _vm._v(
                                                        " até " +
                                                          _vm._s(
                                                            candidate.occurrence
                                                              .end_time
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "feather icon-chevron-right",
                                          }),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _c(
                              "vs-button",
                              {
                                staticClass: "mt-2",
                                attrs: { size: "small", type: "border" },
                                on: { click: _vm.cancelChoice },
                              },
                              [_vm._v(" Cancelar ")]
                            ),
                          ]
                        : _vm.result
                        ? _c("ticket-result", { attrs: { result: _vm.result } })
                        : _c("div", { staticClass: "tv-center tv-muted" }, [
                            _c("i", {
                              staticClass:
                                "feather icon-maximize tv-icon-muted",
                            }),
                            _c("p", { staticClass: "mt-2 mb-0" }, [
                              _vm._v("Aponte a câmera para o QR do ingresso."),
                            ]),
                          ]),
                    ],
                    2
                  ),
                  _vm.recent.length
                    ? _c(
                        "vx-card",
                        {
                          staticClass: "mt-base",
                          attrs: { title: "Entradas desta sessão" },
                        },
                        [
                          _c(
                            "ul",
                            { staticClass: "tv-recent" },
                            _vm._l(_vm.recent, function (entry) {
                              return _c(
                                "li",
                                {
                                  key: entry.id,
                                  staticClass: "tv-recent__item",
                                },
                                [
                                  _c("div", [
                                    _c(
                                      "div",
                                      { staticClass: "tv-recent__name" },
                                      [_vm._v(_vm._s(entry.name))]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "tv-muted tv-recent__meta",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(entry.at) +
                                            " · " +
                                            _vm._s(entry.channelLabel)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  !entry.undone
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "tv-undo",
                                          attrs: {
                                            type: "button",
                                            disabled: entry.undoing,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.undo(entry)
                                            },
                                          },
                                        },
                                        [_vm._v(" Desfazer ")]
                                      )
                                    : _c("span", { staticClass: "tv-muted" }, [
                                        _vm._v("desfeita"),
                                      ]),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }